import React from "react";
import VideoAppointment from "../../../components/Patient/VideoAppointment/VideoAppointment";

const VideoAppointmentMain = () => {
  return <VideoAppointment />;
};

export default VideoAppointmentMain;
